// "More nearby art" for the detail panel. Pure, so vitest covers it.

const R = 6371 // km
const rad = Math.PI / 180

const coord = value => {
  const n = typeof value === 'number' ? value : parseFloat(value)
  return Number.isFinite(n) ? n : null
}

/** Great-circle distance in km between two {lat, lng} points (haversine). */
export function distanceKm(a, b) {
  const lat1 = coord(a.lat) * rad, lat2 = coord(b.lat) * rad
  const dLat = lat2 - lat1
  const dLng = (coord(b.lng) - coord(a.lng)) * rad
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2
  return 2 * R * Math.asin(Math.sqrt(h))
}

/**
 * The `limit` closest items to `art`, as [{ item, km }] sorted ascending.
 * Excludes `art` itself (by id) and anything without usable coordinates.
 */
export function nearbyTo(art, items, limit = 5) {
  if (!art || coord(art.lat) === null || coord(art.lng) === null) return []

  const out = []
  for (const item of items || []) {
    if (!item || item.id === art.id) continue
    if (coord(item.lat) === null || coord(item.lng) === null) continue
    out.push({ item, km: distanceKm(art, item) })
  }
  out.sort((a, b) => a.km - b.km)
  return out.slice(0, limit)
}

export function formatDistance(km) {
  return km < 1 ? `${Math.round(km * 1000)} m` : `${km.toFixed(1)} km`
}
